import type { ShareLimits, CustomShareLimits } from '../dto/tenantModel';

export function defaultShareLimits(): ShareLimits {
  return {
    maxValidDays: 10,
    maxViews: 50,
  };
}

export function getSystemDefinedMaxShareLimits(
  shareLimits: Partial<ShareLimits> | undefined,
): ShareLimits {
  const defaultShareLimit = defaultShareLimits();
  return {
    maxViews: shareLimits?.maxViews ?? defaultShareLimit.maxViews,
    maxValidDays: shareLimits?.maxValidDays ?? defaultShareLimit.maxValidDays,
  };
}

export function getEffectiveShareLimits(
  shareLimits: Partial<ShareLimits> | undefined,
  customShareLimits: CustomShareLimits | undefined,
): ShareLimits {
  const maxLimit = getSystemDefinedMaxShareLimits(shareLimits);

  return {
    maxViews: Math.min(customShareLimits?.maxViews ?? maxLimit.maxViews, maxLimit.maxViews),
    maxValidDays: Math.min(customShareLimits?.maxValidDays ?? maxLimit.maxValidDays, maxLimit.maxValidDays),
  };
}
